import React from 'react';
import { interpolateBlues } from 'd3';

import PieChart from '../PieChart';

export default function HumidityDoughnut(props) {
  const color = interpolateBlues(props.value / 100);
  return (
    <g>
      <PieChart
        value={props.value}
        max={100}
        units="%"
        colors={[color, 'lightgrey']}
      />
      {props.showLabel && <text fill={color} transform="translate(20, 0)">{`${props.value}%`}</text>}
    </g>
    
  )
}


// WEBPACK FOOTER //
// ./src/components/HumidityDoughnut/HumidityDoughnut.component.js